// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ImageModel } from "@insite/client-framework/Types/ApiModels";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss } from "@west/XDL/Utilities";
import React, { FC, useState } from "react";
import ReactPlayer, { ReactPlayerProps } from "react-player";

interface OwnProps extends ReactPlayerProps {
    imageUrl?: ImageModel["mediumImagePath"];
    extendedStyles?: VideoPlayerStyles;
}

export interface VideoPlayerStyles {
    container?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export const videoPlayerStyles: VideoPlayerStyles = {};

const VideoPlayer: FC<OwnProps> = ({ imageUrl, controls = true, extendedStyles, ...rest }) => {
    const [styles] = useState(() => mergeWithCss(videoPlayerStyles, extendedStyles));

    const [isVideoLoaded, setIsVideoLoaded] = React.useState(false);

    const onReadyHandler = () => {
        setIsVideoLoaded(true);
    };

    if (!imageUrl) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} data-test-selector="VideoPlayer">
            {!isVideoLoaded && <LoadingSpinner {...styles.spinner} />}
            <ReactPlayer url={imageUrl} onReady={onReadyHandler} controls={controls} {...rest} />
        </StyledWrapper>
    );
};

export default VideoPlayer;
